module.exports = __webpack_public_path__ + "static/optimierung-der-ressourcen-33da657bed7949152b26b8b2b27dd48f.png";